import { createCalendarEvents, updateCalendarEvent } from '@/services/calendar_service'

export default {
  data () {
    return {
      savingEvent: false
    }
  },
  methods: {
    eventPatientName (patient) {
      if (!patient) return ''
      if (patient.name || patient.surname) return `${patient.name || ''} ${patient.surname || ''}`.trim()
      return patient.value || ''
    },
    async saveEvents ({ calendarId = 0, patient, calendarDate, calendarType, calendarTypeDescription, calendarDescription, action }) {
      debugger
      const targetPatients = (patient && typeof patient == 'object') ? [patient] : this.targetPatients
      if (!targetPatients || targetPatients.length == 0) return
      this.savingEvent = true
      try {
        if (calendarId > 0) {
          const p = targetPatients[0]
          await updateCalendarEvent({
            ...this.calendarItem,
            action,
            calendarId,
            patientId: p.patientId,
            patient: this.eventPatientName(p),
            calendarDate,
            calendarType,
            calendarTypeDescription,
            calendarDescription,
            updatedBy: this.$store.state.user.userId
          })
          this.$message({ message: 'Evento actualizado', type: 'success' })
        } else {
          const events = targetPatients.map(p => ({
            action,
            patientId: p.patientId,
            patient: this.eventPatientName(p),
            calendarDate,
            calendarType,
            calendarTypeDescription,
            calendarDescription,
            createdBy: this.$store.state.user.userId
          }))
          await createCalendarEvents(events)
          this.$message({ message: events.length == 1 ? 'Evento creado' : `${events.length} eventos creados`, type: 'success' })
        }
        // this.eventDialogVisible = false
        // if (this.afterEventsSaved) this.afterEventsSaved()
      } catch (err) {
        const message = err.response && err.response.data
          ? err.response.data.error || err.response.data.err && err.response.data.err.details
          : 'No se pudo crear el evento'
        this.$message({ message, type: 'error' })
      } finally {
        this.savingEvent = false
      }
    }
  }
}
